<div class="deviceAndSelectionWrapper" [class.masterDevice]="isMaster" [class.additionalPadding]="additionalPadding">
	<div [class]="isMaster ? 'device master' : 'device'">
		<div class="name">
			<mat-icon
				fontSet="fas"
				[fontIcon]="getFontIcon()"
				inline
				[style.fontSize]="isMaster ? '30px' : '24px'"
				style="text-align: left"
			/>
			<div class="nameDesc">
				{{ isMaster ? "MASTER" : "" }}
				{{ inputChannel["displayName"] ?? inputChannel.name | translate }}
			</div>
		</div>
		<div [class.masterSlider]="isMaster" class="slider" [class.normalSlider]="!isMaster">
			<mat-slider appAmplitude [ampValue]="ampVolume" discrete style="width: 100%" color="accent">
				<input matSliderThumb [value]="volume" (valueChange)="volumeChanged.emit($event)" />
			</mat-slider>
		</div>
		<div class="actions">
			@if (showSolo) {
				<button color="accent" mat-icon-button (click)="soloButtonClicked.emit()" [class.onSolo]="solo">
					<mat-icon svgIcon="audio_solo" />
				</button>
			}

			@if (showRec) {
				<button
					color="accent"
					mat-icon-button
					matTooltipClass="accent"
					matTooltip="{{ T.AUDIO_INPUT_DEVICE_BUTTON_SHOW_RECORDING | translate }}"
					[disabled]="isRecDisabled"
					(click)="recButtonClicked.emit()"
					[class.on]="mutedRec && !isRecDisabled"
				>
					<mat-icon [svgIcon]="mutedRec && !isRecDisabled ? 'audio_rec_not' : 'audio_rec'" />
				</button>
			}

			@if (showLife) {
				<button
					color="accent"
					mat-icon-button
					matTooltipClass="accent"
					matTooltip="{{ T.AUDIO_INPUT_DEVICE_BUTTON_SHOW_LIFE | translate }}"
					[disabled]="isBroadcastDisabled"
					(click)="broadcastButtonClicked.emit()"
					[class.on]="mutedBroadcast && !isBroadcastDisabled"
				>
					<mat-icon [svgIcon]="mutedBroadcast && !isBroadcastDisabled ? 'audio_transmission_not' : 'audio_transmission'" />
				</button>
			}

			@if (showMute) {
				<button
					color="accent"
					mat-icon-button
					matTooltipClass="accent"
					matTooltip="{{ T.AUDIO_INPUT_DEVICE_BUTTON_SHOW_MUTE | translate }}"
					[disabled]="isMuteDisabled"
					(click)="muteButtonClicked.emit()"
					[class.on]="muted && !isMuteDisabled"
				>
					<mat-icon [svgIcon]="muted && !isMuteDisabled ? 'audio_speaker_not' : 'audio_speaker'" />
				</button>
			}
		</div>
	</div>

	@if (currentAudioOutputChannels?.length > 1 && settings.audioDeviceMode !== AudioDeviceMode.Pure) {
		<div class="selection">
			<mat-chip-listbox multiple aria-label="Speaker Selection">
				@for (audioOutputChannel of currentAudioOutputChannels | orderBy: "displayName"; track audioOutputChannel) {
					<mat-chip-option
						(selectionChange)="handleAudioChannelSelection(inputChannel?.id, audioOutputChannel?.id, $event)"
						[selected]="selectedAudioOutputChannelIds?.includes(audioOutputChannel?.id)"
						color="accent"
					>
						{{ audioOutputChannel.displayName }}
					</mat-chip-option>
				}
			</mat-chip-listbox>
		</div>
	}
</div>
